"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeCard = void 0;

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

/**
 * `Large` is a card with one image one tall image, and text for title and subtitle
 * at the bottom.
 */
var LargeCard = function LargeCard(_ref) {
  _objectDestructuringEmpty(_ref);

  return null;
};

exports.LargeCard = LargeCard;
//# sourceMappingURL=LargeCard.js.map